<template>
  <div class="quota-resolver">
    <span class="quota-resolver__hint"> {{ $t('hint') + ":" }}</span>
    <AppWithLoading :fetch="fetchIfNull">
      <slot
        v-if="quota"
        :quota="quota"
      />
    </AppWithLoading>
  </div>
</template>

<script>
import useAccount from '@/compositions/accounting/useAccount';
import AppWithLoading from '@/components/AppWithLoading';

export default {
  name: 'QuotaResolver',
  components: { AppWithLoading },
  setup() {
    const { quota, fetchIfNull } = useAccount();

    return {
      quota,
      fetchIfNull,
    };
  },
};
</script>

<style lang="scss" scoped>
  .quota-resolver {
    margin-top: 20px;
    border: 1px solid #C2C2C2;
    border-radius: 4px;
    padding: 20px 15px 12px;
    position: relative;

    &__hint {
      content: 'Notify by:';
      left: 15px;
      top: 0;
      transform: translateY(-50%);
      background: white;
    }
  }
</style>

<i18n locale="ru" lang="yaml">
  hint: Уведомить по
</i18n>

<i18n locale="en" lang="yaml">
  hint: Notify by
</i18n>
